import React, { useState } from 'react';
import { set } from 'dot-prop-immutable';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch } from '@whalecloud/fdx';
import CustomInput from '@whalecloud/page-builder-base-components/components/CustomInput';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import CommonDateSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonDateSettings';

const { Panel } = Collapse;

const valueKey = 'data.formItemSettings';

const RangePickerSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;
  const {
    separator = '~',
    allowEmpty = [false, false],
    disabled = [false, false],
    showTime,
  } = formItemSettings;

  const [startEmpty, setStartEmpty] = useState(allowEmpty[0]);
  const [endEmpty, setEndEmpty] = useState(allowEmpty[1]);
  const [startDisable, setStartDisable] = useState(disabled[0]);
  const [endDisable, setEndDisable] = useState(disabled[1]);

  const initialValues = {
    separator,
    startEmpty,
    endEmpty,
    startDisable,
    endDisable,
    showTime,
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let propName = `${valueKey}.${key}`;
      let relValue = obj[key];
      if (key === 'startEmpty') {
        setStartEmpty(obj[key]);
        propName = `${valueKey}.allowEmpty`;
        relValue = [obj[key], endEmpty];
      }
      if (key === 'endEmpty') {
        setEndEmpty(obj[key]);
        propName = `${valueKey}.allowEmpty`;
        relValue = [startEmpty, obj[key]];
      }
      if (key === 'startDisable') {
        setStartDisable(obj[key]);
        propName = `${valueKey}.disabled`;
        relValue = [obj[key], endDisable];
      }
      if (key === 'endDisable') {
        setEndDisable(obj[key]);
        propName = `${valueKey}.disabled`;
        relValue = [startDisable, obj[key]];
      }

      const newElement = set(element, propName, relValue);

      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages.PAGEBUIDER_SETTINGS} key="1">
        <CommonItemSettings />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_SEPARATOR} name="separator">
            <CustomInput />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_ALLOW_START_EMPTY} name="startEmpty" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_ALLOW_END_EMPTY} name="endEmpty" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_START_DISABLE} name="startDisable" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_END_DISABLE} name="endDisable" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages.PAGEBUIDER_SETTINGS_SHOW_TODAY} name="showTime" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
        <CommonDateSettings pickerFormat="YYYY-MM-DD" />
      </Panel>
    </Collapse>

  );
};

export default RangePickerSettings;
